/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGameShowNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGameShowNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Play Game Shows Together!",
    "Game Show Night Awaits!",
    "Fun and Games for Everyone!",
  ],
  title: "Game Show Night",
  description: "Organize a fun game show night.",
  longDescription:
    "Gather your friends for an exciting game show night! Choose a date, decide on games to play, and plan refreshments!",
  emoji: "🎤",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Game Show Night",
          emoji: "🎤",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the game show night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to play?",
            description: "What games should we focus on during the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we consider?",
                emoji: "🎲",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we prepare for the game show night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍿",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Game Show Begin!",
    outroDescription: "Your game show night plans are set! Enjoy the fun!",
  },
};
